import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function MoviePortalFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [contentType, setContentType] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const categories = [
    { id: "all", name: "Todos" },
    { id: "action", name: "Ação" },
    { id: "comedy", name: "Comédia" },
    { id: "drama", name: "Drama" },
    { id: "horror", name: "Terror" },
    { id: "scifi", name: "Sci-Fi" },
    { id: "romance", name: "Romance" },
    { id: "documentary", name: "Documentário" },
  ];

  const contentTypes = [
    { id: "all", name: "Todos" },
    { id: "movie", name: "Filmes" },
    { id: "series", name: "Séries" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/movie_portal?page=${pageNum}&limit=16`;
      if (category !== "all") url += `&genre=${category}`;
      if (contentType !== "all") url += `&type=${contentType}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching movies:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category, contentType]);

  const handleEditPost = (post) => {
    setSelectedItem(null);
    setEditingPost(post);
  };

  const handlePostUpdated = (updatedPost) => {
    setPosts((prev) => prev.map((p) => (p._id === updatedPost._id ? updatedPost : p)));
    setEditingPost(null);
  };

  const handlePostDeleted = (postId) => {
    setPosts((prev) => prev.filter((p) => p._id !== postId));
    setSelectedItem(null);
  };

  if (loading && posts.length === 0) {
    return <div className="movieportal_feed_loading"><div className="movieportal_loader"></div><span>Carregando filmes...</span></div>;
  }

  return (
    <div className="movieportal_feed">
      <div className="movieportal_header">
        <h1>Filmes & Séries</h1>
        <p>Recomendações da comunidade</p>
      </div>

      <div className="movieportal_filters">
        <div className="movieportal_type_filter">
          {contentTypes.map((t) => (
            <button key={t.id} className={contentType === t.id ? "active" : ""} onClick={() => setContentType(t.id)}>
              {t.name}
            </button>
          ))}
        </div>
        <div className="movieportal_genre_filter">
          {categories.map((cat) => (
            <button key={cat.id} className={category === cat.id ? "active" : ""} onClick={() => setCategory(cat.id)}>
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      {posts.length === 0 ? (
        <div className="movieportal_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"/>
          </svg>
          <h3>Nenhum conteúdo encontrado</h3>
          <p>Seja o primeiro a recomendar!</p>
        </div>
      ) : (
        <div className="movieportal_grid">
          {posts.map((post) => (
            <div key={post._id} className="movieportal_card" onClick={() => setSelectedItem(post)}>
              <div onClick={(e) => e.stopPropagation()}>
                <FeedPostMenu
                  post={post}
                  onEdit={handleEditPost}
                  onPostDeleted={handlePostDeleted}
                />
              </div>
              <div className="movieportal_poster">
                <img src={post.moviePortalData?.posterImage || post.images?.[0]?.url || post.images?.[0] || "/images/default-movie.png"} alt="" />
                {post.moviePortalData?.rating && (
                  <span className="movieportal_rating">⭐ {post.moviePortalData.rating.toFixed(1)}</span>
                )}
                <span className="movieportal_type">{post.moviePortalData?.contentType === "series" ? "Série" : "Filme"}</span>
              </div>
              <div className="movieportal_card_content">
                <h3>{post.moviePortalData?.title || post.text}</h3>
                <p className="movieportal_year">{post.moviePortalData?.year}</p>
                <div className="movieportal_genres">
                  {post.moviePortalData?.genres?.slice(0, 2).map((genre, i) => (
                    <span key={i}>{genre}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="movieportal_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais"}
          </button>
        </div>
      )}

      {selectedItem && (
        <div className="movieportal_modal_overlay" onClick={() => setSelectedItem(null)}>
          <div className="movieportal_modal" onClick={(e) => e.stopPropagation()}>
            <button className="movieportal_modal_close" onClick={() => setSelectedItem(null)}>✕</button>
            <div className="movieportal_modal_backdrop" style={{ backgroundImage: `url(${selectedItem.moviePortalData?.backdropImage || selectedItem.moviePortalData?.posterImage})` }}></div>
            <div className="movieportal_modal_content">
              <div className="movieportal_modal_poster">
                <img src={selectedItem.moviePortalData?.posterImage || selectedItem.images?.[0]} alt="" />
              </div>
              <div className="movieportal_modal_info">
                <h2>{selectedItem.moviePortalData?.title}</h2>
                <div className="movieportal_modal_meta">
                  <span>{selectedItem.moviePortalData?.year}</span>
                  {selectedItem.moviePortalData?.duration && <span>{selectedItem.moviePortalData.duration}</span>}
                  {selectedItem.moviePortalData?.rating && <span>⭐ {selectedItem.moviePortalData.rating.toFixed(1)}</span>}
                </div>
                <div className="movieportal_modal_genres">
                  {selectedItem.moviePortalData?.genres?.map((genre, i) => (
                    <span key={i}>{genre}</span>
                  ))}
                </div>
                <p className="movieportal_modal_synopsis">{selectedItem.moviePortalData?.synopsis || selectedItem.text}</p>
                {selectedItem.moviePortalData?.director && (
                  <p className="movieportal_director"><strong>Diretor:</strong> {selectedItem.moviePortalData.director}</p>
                )}
                {selectedItem.moviePortalData?.cast?.length > 0 && (
                  <p className="movieportal_cast"><strong>Elenco:</strong> {selectedItem.moviePortalData.cast.slice(0, 5).join(", ")}</p>
                )}
                <Link to={`/profile/${selectedItem.user.username}`} className="movieportal_recommender">
                  <img src={selectedItem.user.picture} alt="" />
                  <span>Recomendado por {selectedItem.user.first_name}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
